/**
 * The 4pt grid from design-system/04-Layout-And-Shape.md §1. Identical numbers in Kotlin and Swift.
 *
 * Stated in `px`, never `rem`. `rem` scales with the browser's root font size, which would move the grid
 * out from under a layout the two apps hold fixed. Text respects the reader's size preference through the
 * type scale; the grid does not move under it.
 */
export const Space = {
  s0_5: '2px',
  s1: '4px',
  s2: '8px',
  s3: '12px',
  s4: '16px',
  s5: '20px',
  s6: '24px',
  s8: '32px',
  s10: '40px',
  s12: '48px',
} as const;

/** design-system/04-Layout-And-Shape.md §3 — 56 in child mode is a data-quality rule, not a nicety. */
export const TouchTarget = {
  child: '56px',
  parent: '48px',
} as const;

export const Radius = {
  s: '8px',
  m: '12px',
  l: '16px',
  xl: '24px',
  pill: '999px',
} as const;

/**
 * design-system/05-Motion-And-Feedback.md §1, in milliseconds.
 *
 * Nothing is longer than 420ms, and nothing here may represent elapsed time in child mode (BR-12).
 */
export const Motion = {
  instant: 100,
  quick: 180,
  standard: 260,
  slow: 420,
  /** The memory stimulus fading before it covers. There is no countdown; this fade is the only warning. */
  exposureFade: 300,
} as const;
